import { colors } from '@lmc/common/constants'
import dayjs from 'dayjs'
import Highcharts from 'highcharts'
import ReactHighcharts from 'highcharts-react-official'
import PropTypes from 'prop-types'
import { useRef } from 'react'

const Highchart = (props: any) => {
  const {
    // title,
    subTitle,
    yMax,
    yMin,
    xAxisLabel,
    yAxisLabel,
    yCeiling,
    yAllowDecimals = true,
    yAxisCategories,
    chartType,
    series,
    // to,
    from,
    tooltip,
    legendEnabled,
    minX,
    maxX
  } = props.config
  const chartComponentRef = useRef(null)

  const floor = from
    ? Date.parse(dayjs(from).startOf('day').toString())
    : undefined

  const oneDay = 3600 * 1000 * 24
  const config: Highcharts.Options = {
    chart: {
      type: chartType || 'line',
      backgroundColor: 'none'
    },
    credits: {
      enabled: false
    },
    title: {
      text: ''
    },
    subtitle: {
      text: subTitle
    },
    xAxis: {
      min: minX,
      max: maxX,
      type: 'datetime',
      floor,
      minPadding: 0.07,
      maxPadding: 0.07,
      showLastLabel: true,
      endOnTick: true,
      labels: {
        format: '{value:%e %b}'
      },
      title: {
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
          color: colors.black
        },
        text: xAxisLabel || 'Date'
      }
    },
    yAxis: {
      max: yMax,
      min: yMin || 0,
      allowDecimals: yAllowDecimals,
      ceiling: yCeiling,
      categories: yAxisCategories,
      title: {
        text: yAxisLabel,
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
          color: colors.black
        }
      }
    },
    plotOptions: {
      // turboThreshold: 10000,
      column: {
        maxPointWidth: 50,
        stacking: 'normal',
        pointRange: oneDay,
        pointPadding: 0.05
        // groupPadding: 0.2,
      },
      spline: {
        lineWidth: 3,
        animation: {
          duration: 1000
        },
        marker: {
          radius: 4,
          enabled: true,
          lineWidth: 3,
          fillColor: colors.background,
          lineColor: colors.purple
        }
      },
      line: {
        lineWidth: 3,
        animation: {
          duration: 1000
        },
        marker: {
          radius: 4,
          enabled: true,
          lineWidth: 3,
          fillColor: colors.background,
          lineColor: colors.purple
        }
      }
    },
    legend: {
      enabled: legendEnabled || false
    },
    series,
    accessibility: {
      enabled: false
    }
  }

  if (tooltip) {
    // @ts-ignore
    config.tooltip = tooltip // bug fix...
  }

  return (
    <div style={{ background: 'white', borderRadius: 16 }}>
      <div style={{ paddingTop: 24, paddingRight: 12 }}>
        <ReactHighcharts
          options={config}
          highcharts={Highcharts}
          ref={chartComponentRef}
        />
      </div>
    </div>
  )
}

Highchart.propTypes = {
  config: PropTypes.object.isRequired
}

export default Highchart
